<template lang="html">
  <div class="vacancy-item-links">
    <span v-for="(module) in activeModules">
      <router-link :disabled="disabled" tag="a" :target="target" :to="routes[module.name]">
        <i :class="icons[module.name]"/>
      </router-link>
    </span>
  </div>
</template>


<script>
export default {
  name: 'vacancy-modules',

  props: {
    modules: Array,
    vacancyId: String,
    disabled: Boolean,
    target: String
  },

  data () {
    return {
      routes: {
        'test': { name: 'vacancy_tests', params: {id: this.vacancyId} },
        'voicebot': { name: 'vacancy-voice-bot', params: {id: this.vacancyId} },
        'searchbot': { name: 'vacancy-search-bot', params: {id: this.vacancyId} },
        'video_interview': { name: 'vacancy_video', params: {id: this.vacancyId} }
      },
      icons: {
        'searchbot': 'fa fa-search',
        'voicebot': 'fa fa-volume-up',
        'video_interview': 'fa fa-video-camera'
      }
    }
  },

  computed: {
    activeModules () {
      return this.modules.filter(module => module.is_active)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.vacancy-item-links {
  width: 100%;

  a {
    color: $green;

    &:hover {
      color: unset;
    }
  }
}
</style>
